export const REQUEST_INFO_TALENT = "REQUEST_INFO_TALENT";
